import { isNull } from './common-utils';
import { SERVER_URL } from '../core/Const';
import * as firebase from 'firebase';

/**
 * wrapepr fetch API
 * <pre>Cannot GET <pre>Cannot POST <pre>Cannot PUT <pre>Cannot OPTION
 */
export class CoreAjaxHelper {
    /**
     * handler kalau login sudah habis
     */
    static LOGIN_EXPIRED_HANDLER: () => any;

    /**
     * flag enable cross origin atau tidak. normal dalam web = false, untuk chrome app = true 
     */
    static ENABLE_CROSS_ORIGIN_REQUEST: boolean = true;

    baseUrl: string;

    requestIncrementer: number = new Date().getTime() + Math.ceil(Math.random() * 1000);

    /**
     * constructor util. http akan di pass oleh angular
     */
    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl as string;
    }

    /**
     * generate full url dari service
     * @param serviceUrl url service. ini relative path nya saja
     */
    generateFullUrl(serviceUrl: string): string {
        if (serviceUrl.startsWith("//")) {
            serviceUrl = serviceUrl.substr(1);
        }
        if (isNull(this.baseUrl) || this.baseUrl.length === 0) {
            return serviceUrl;
        }
        let rtvl = this.baseUrl;
        if (this.baseUrl.endsWith('/')) {// base url ada / di akhir
            if (serviceUrl.startsWith('/')) {
                rtvl += serviceUrl.substr(1);
            } else {
                rtvl = rtvl + serviceUrl;
            }
        } else {// tidak di akhiri / pada base, bisa jadi eprlu di tambahkan /
            if (serviceUrl.startsWith('/')) {
                rtvl += serviceUrl;
            } else {
                rtvl = rtvl + '/' + serviceUrl;
            }
        }
        return rtvl;
    }

    /**
     * check login expired atau tidak. kalau return true , callback tidak akan di panggil, login expired langsung di trigger
     */
    doCheckLoginExpired(ajaxResult: any): boolean {
        if (CoreAjaxHelper.LOGIN_EXPIRED_HANDLER == null || typeof CoreAjaxHelper.LOGIN_EXPIRED_HANDLER === 'undefined') {
            return false;
        }
        if (ajaxResult.errorCode === 'ERROR_LOGIN_EXPIRED') {
            CoreAjaxHelper.LOGIN_EXPIRED_HANDLER();
            return true;
        }
        return false;
    }

    generateMarkerReq(): string {
        const dt: Date = new Date();
        return `${dt.getHours()}_${dt.getMinutes()}_${dt.getSeconds()}_${dt.getMilliseconds()}`;
    }
    /**
     * invoke get. 
     * promise : success : data , onfailure : {
     *      message : "pesan error" , 
     *      errorCode : "kode error", 
     *      
     * }
     */
    get(url: string): Promise<any> {
        if (url.indexOf('?') < 0) {
            url += "?";
        } 
        if (!isNull(this.baseUrl) && this.baseUrl.length > 0) {
            url = this.baseUrl + url;
        }

        return new Promise<any>(async (accept: (d: any) => any, reject: (exc: any) => any) => {
            const app: firebase.app.App = window['firebaseApp'];
            const tkn = await app.auth().currentUser!.getIdToken(false);
            window['firebase-auth-token'] = tkn;
            let mode: any = this.getMode();
            if (mode !== 'same-origin') {
                const h: any = {
                    "authorization": 'Bearer ' + window['firebase-auth-token']
                };
                if (window['lang-code'] && window['lang-code'].length > 0) {
                    h['lang-code'] = window['lang-code'];
                }
                window['$'].ajax({
                    url: url,
                    method: 'get',
                    crossDomain: true,
                    contentType: "text/plain",
                    headers: h,
                    error: (jqXHR: any, textStatus: string, errorThrown: any) => {
                        reject(errorThrown);
                    }
                }).done(
                    (jsonData: any) => {
                        // this.jsonResultHandler(d, accept, reject, extractResultAsJsonStandard);
                        if (jsonData.haveError != null && typeof jsonData.haveError !== 'undefined') {
                            if (jsonData.haveError) {
                                if (this.doCheckLoginExpired(jsonData)) {
                                    return;
                                }
                                console.log('[ajaxhelper.jsonResultHandler] ', jsonData);
                                reject({ additionalErrorData: jsonData.additionalErrorData, message: jsonData.errorMessage, errorCode: jsonData.errorCode });
                                return;
                            }
                            accept(jsonData.data);
                        }
                    });
            } else {
                const getParameter: any = {
                    credentials: 'include',
                    mode: this.getMode(),
                };
                getParameter.headers = this.plugAuthTokenToHeader(getParameter.headers);
                this.appendToHeader(getParameter.headers, 'content-type', 'application/xml');
                fetch(this.appendCacheEscapeUrl(url), getParameter).then((d: any) => {
                    this.jsonResultHandler(d, accept, reject);
                }).catch((exc: any) => {
                    console.error(`[CoreAjaxHelper#get] gagal get request. url [${url}],error: `, exc);
                    reject(exc);
                });
            }

        });
    }

    plugAuthTokenToHeader(header: Headers): any {
        if (!header) {
            header = new Headers();
        }
        if (window['firebase-auth-token']) {
            this.appendToHeader(header, 'authorization', 'Bearer ' + window['firebase-auth-token']);
        }
        if (window['lang-code'] && window['lang-code'].length > 0) {
            this.appendToHeader(header, 'lang-code', window['lang-code']);
        }
        return header;
    }
    generateStringValue(val: any): string | null {
        if (val == null || typeof val === 'undefined') {
            return null;
        }
        if (typeof val === 'number') {
            return val + '';
        }
        if (typeof val === 'string') {
            return val;
        }
        return JSON.stringify(val);
    }

    /**
     * handler untuk json result
     */
    jsonResultHandler(rawData: Response, accept: (d: any) => any, reject: (exc: any) => any, extractResultAsJsonStandard?: boolean) {
        if (isNull(extractResultAsJsonStandard)) {
            extractResultAsJsonStandard = true;
        }
        if (rawData.ok) {
            rawData.json().then((jsonData: any) => {
                if (extractResultAsJsonStandard) {
                    if (jsonData.haveError != null && typeof jsonData.haveError !== 'undefined') {
                        if (jsonData.haveError) {
                            if (this.doCheckLoginExpired(jsonData)) {
                                return;
                            }
                            // console.log('[ajaxhelper.jsonResultHandler] ', jsonData);
                            reject({ additionalErrorData: jsonData.additionalErrorData, message: jsonData.errorMessage, errorCode: jsonData.errorCode });
                            return;
                        }
                    }
                    accept(jsonData.data);
                    return;
                } else {
                    accept(jsonData);
                }
            }).catch(exc => {
                console.error('[CoreAjaxHelper] gagal memproses data sebagai JSON. ada yang salah dengan data hasil ajax.erorr : ', exc, '.raw data : ', rawData);
                reject(exc);
            });
            return;
        } else {
            reject({ message: 'Network failed, response code :  ' + rawData.status, errorCode: rawData.status });
            return;
        }
    }
    makeJsonStringifyParam( param: any ): any  {
        const rtvl: any  = {} ; 
        Object.keys(param).forEach( key => {
            // const type 
            if ( typeof param[key] === 'object') {
                rtvl[key] = JSON.stringify(param[key]) ;
            } else {
                rtvl[key] = param[key] ; 
            }
        });
        return rtvl ; 
    }
    /**
     * worker untuk invoke post 
     * @param extractResultAsJsonStandard default = true, hasil akan di bongkar dengan standard json result
     */
    post(url: string, postParam: any, extractResultAsJsonStandard?: boolean): Promise<any> {
        if (url.indexOf('?') < 0) {
            url += "?";
        }

        return new Promise<any>(async (accept: (d: any) => any, reject: (exc: any) => any) => {
            const app: firebase.app.App = window['firebaseApp'];
            const tkn = await app.auth().currentUser!.getIdToken(false);
            window['firebase-auth-token'] = tkn;
            // var formData = new FormData();
            // formData.append("json", JSON.stringify(postParam));
            if (!postParam) {
                postParam = {};
            }
            if (!isNull(this.baseUrl) && this.baseUrl.length > 0) {
                url = this.baseUrl + url;
            }
            postParam.reqMarker = this.generateMarkerReq();
            let mode: any = this.getMode();
            if (mode !== 'same-origin') {
                const h: any = {
                    "authorization": 'Bearer ' + window['firebase-auth-token'],
                    // "Content-type": "application/x-www-form-urlencoded"
                };
                if (window['lang-code'] && window['lang-code'].length > 0) {
                    h['lang-code'] = window['lang-code'];
                }
                window['$'].ajax({
                    url: url,
                    // data: this.makeJsonStringifyParam(postParam),
                    data: postParam, 
                    method: 'post',
                    crossDomain: true,
                    contentType: "application/x-www-form-urlencoded",
                    headers: h,
                    error: (jqXHR: any, textStatus: string, errorThrown: any) => {
                        reject(errorThrown);
                    }
                }).done(
                    (jsonData: any) => {
                    // this.jsonResultHandler(d, accept, reject, extractResultAsJsonStandard);
                    if (jsonData.haveError != null && typeof jsonData.haveError !== 'undefined') {
                        if (jsonData.haveError) {
                            if (this.doCheckLoginExpired(jsonData)) {
                                return;
                            }
                            // console.log('[ajaxhelper.jsonResultHandler] ', jsonData);
                            reject({ additionalErrorData: jsonData.additionalErrorData, message: jsonData.errorMessage, errorCode: jsonData.errorCode });
                            return;
                        }
                        accept(jsonData.data);
                    }
                });
            } else {
                let h: Headers = new Headers();
                h.append('Accept', 'application/json');
                h.append('Content-Type', 'application/json');
                if (window['lang-code'] && window['lang-code'].length > 0) {
                    h.append('lang-code', window['lang-code']);
                }
                h = this.plugAuthTokenToHeader(h);
                let reqInit: RequestInit = {
                    method: 'post',
                    redirect: 'follow',
                    mode: this.getMode(),
                    headers: h,
                    // body: formData,
                    credentials: 'include'
                };
                if (postParam != null && typeof postParam !== 'undefined') {
                    reqInit.body = JSON.stringify(postParam);
                } else {
                    reqInit.body = new FormData();
                }
                let req: Request = new Request(this.appendCacheEscapeUrl(url), reqInit);
                fetch(req).then((d: Response) => {
                    this.jsonResultHandler(d, accept, reject, extractResultAsJsonStandard);
                }).catch((exc: any) => {
                    reject(exc);
                });
            }
            // console.log('[ajaxhelper] invoke post dengan data :  ', postParam);

        });
    }
    getMode(): 'cors' | 'same-origin' {
        if (this.baseUrl && this.baseUrl.length > 0) {
            if (this.baseUrl.indexOf(window.location.origin) < 0) {
                return 'cors';
            }
        }
        return 'same-origin';
        // return CoreAjaxHelper.ENABLE_CROSS_ORIGIN_REQUEST ? 'cors' : 'same-origin';
        // return 'same-origin';
    }

    /**
     * invoke method : put
     */
    put(url: string, param?: any): Promise<any> {
        
        let mode = this.getMode();
        if (mode === 'cors') {
            // kalau cross origin. maka di kirim dengan post. tidak ada cerita nya put untuk cross origin
            return this.post(url, param);
        }
        if (!isNull(this.baseUrl) && this.baseUrl.length > 0) {
            url = this.baseUrl + url;
        }
        return new Promise<any>(async (accept: (d: any) => any, reject: (exc: any) => any) => {

            const app: firebase.app.App = window['firebaseApp'];
            const tkn = await app.auth().currentUser!.getIdToken(false);
            window['firebase-auth-token'] = tkn;
            let h: Headers = new Headers();
            /* gede sutarsa (14 dec 2017)redundan, ini jadinya pada bagian header ada data yang sama dengab body, jadinya di server request gagal
           if (param != null && typeof param != 'undefined') {
               let keys: string[] = Object.keys(param);
               for (let k of keys) {
                   h.append(k, param[k]);
               }
           }
           */
            h.append('Accept', 'application/json');
            h.append('Content-Type', 'application/json');

            h = this.plugAuthTokenToHeader(h);
            let reqInit: RequestInit = {
                method: 'put',
                redirect: 'follow',
                mode: this.getMode(),
                credentials: 'include',
                headers: h,
            };
            if (param != null && typeof param !== 'undefined') {
                reqInit.body = JSON.stringify(param);
            }
            let req: Request = new Request(this.appendCacheEscapeUrl(url), reqInit);
            fetch(req).then((d: Response) => {
                this.jsonResultHandler(d, accept, reject);
            }).catch((exc: any) => {
                reject(exc);
            });
        });
    }

    /**
     * http delete. disingkat agar tidak bentrok dengan statement delete
     */
    del(url: string): Promise<any> {
        if (!isNull(this.baseUrl) && this.baseUrl.length > 0) {
            url = this.baseUrl + url;
        }
        return new Promise<any>(async (accept: (d: any) => any, reject: (exc: any) => any) => {

            const app: firebase.app.App = window['firebaseApp'];
            const tkn = await app.auth().currentUser!.getIdToken(false);
            window['firebase-auth-token'] = tkn;
            let req: Request = new Request(this.appendCacheEscapeUrl(url), {
                method: 'delete',
                redirect: 'follow',
                mode: this.getMode(),
                credentials: 'include',
                headers: this.plugAuthTokenToHeader(null!)
            });
            fetch(req).then((d: any) => {
                this.jsonResultHandler(d, accept, reject);
            }).catch((exc: any) => {
                reject(exc);
            });
        });
    }

    /**
     * ajax dengan method get
     */
    sendAjaxGet<RESULT>(url: string, onSuccess: (data: RESULT) => any, onFailure: (errorCode: string, errorMessage: string, actualException: any) => any) {
        this.get(url).then(d => { onSuccess(d); })
            .catch((exc: any) => {
                onFailure(exc.errorCode, exc.message, exc);
            });
    }

    /**
     * kirim ajax post request
     */
    sendAjaxPost<PARAM, RESULT>(url: string, param: PARAM, onSuccess: (data: RESULT) => any, onFailure: (errorCode: string, errorMessage: string, actualException: any) => any) {
        this.post(url, param).then((d: any) => {
            onSuccess(d);
        })
            .catch(exc => {
                onFailure(exc.errorCode, exc.message, exc);
            });

    }

    /**
     * send <i>PUT</i>
     */
    sendAjaxPut<PARAM, RESULT>(url: string, param: PARAM, onSuccess: (data: RESULT) => any, onFailure: (errorCode: string, errorMessage: string, actualException: any) => any) {
        this.put(url, param).then(d => {
            onSuccess(d);
        }).catch(exc => {
            onFailure(exc.errorCode, exc.message, exc);
        });
    }

    sendAjaxDelete<RESULT>(url: string, onSuccess: (data: RESULT) => any, onFailure: (errorCode: string, errorMessage: string, actualException: any) => any) {

        this.del(url).then(d => {
            onSuccess(d);
        }).catch(exc => {
            onFailure(exc.errorCode, exc.message, exc);
        });

    }

    private appendCacheEscapeUrl(url: string): string {

        let rtvl: string = url;
        let marker: string = 'add_' + this.requestIncrementer;
        this.requestIncrementer++;
        if (url.indexOf('?') < 0) {
            rtvl += "?someNotUsedParam=" + marker;
        } else {
            rtvl += "&someNotUsedParam=" + marker;
        }
        return rtvl;

    }
    /**
     * helper untuk append header
     */
    private appendToHeader(header: any, key: string, value: string) {
        if (header.append) {
            header.append(key, value);
        } else {
            header[key] = value;
        }
    }

}

export function getAjaxhelper(): CoreAjaxHelper {
    return new CoreAjaxHelper(SERVER_URL);
}


// WEBPACK FOOTER //
// ./src/utils/CoreAjaxHelper.ts